/* eslint-disable jsx-a11y/label-has-associated-control */
import { Button, CircularProgress, InputAdornment, TextField, Typography } from '@material-ui/core';
import { EnvelopeSimpleIcon, InfoIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { EMAIL_ALREADY_USED_MESSAGE } from '../constants';
import { useStyles } from '../styles';
import { ExistingUser } from '../types';

interface StepEmailProps {
  email: string;
  existingUser: ExistingUser | null;
  checkingEmail: boolean;
  roleLabel: string;
  onEmailChange: (value: string) => void;
  onViewProfile: () => void;
}

const getInitials = (user: ExistingUser) => {
  const first = (user.firstname || '').charAt(0);
  const last = (user.lastname || '').charAt(0);
  return `${first}${last}`.toUpperCase() || 'U';
};

const StepEmail: FC<StepEmailProps> = ({
  email,
  existingUser,
  checkingEmail,
  roleLabel,
  onEmailChange,
  onViewProfile,
}) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.field}>
        <label className={classes.label} htmlFor="consultant-email">
          Email
        </label>
        <TextField
          id="consultant-email"
          className={classes.textField}
          variant="outlined"
          value={email}
          onChange={event => onEmailChange(event.target.value)}
          placeholder="Adresse email"
          type="email"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {checkingEmail ? (
                  <CircularProgress size={18} />
                ) : (
                  <EnvelopeSimpleIcon size={20} color="#8B90A5" />
                )}
              </InputAdornment>
            ),
          }}
        />
      </div>

      {existingUser && (
        <div className={classes.warningBox}>
          <div className={classes.warningTitle}>
            <InfoIcon size={18} />
            <span>{EMAIL_ALREADY_USED_MESSAGE}</span>
          </div>
          <div className={classes.userCard}>
            {existingUser.photoUri ? (
              <img src={existingUser.photoUri} alt="" className={classes.avatar} />
            ) : (
              <div className={classes.avatar}>{getInitials(existingUser)}</div>
            )}
            <div className={classes.userMeta}>
              <Typography className={classes.userName}>
                {`${existingUser.firstname || ''} ${existingUser.lastname || ''}`.trim() ||
                  existingUser.email}
              </Typography>
              {roleLabel ? <div className={classes.userRole}>{roleLabel}</div> : null}
            </div>
            <Button className={classes.viewProfileBtn} onClick={onViewProfile}>
              Voir le profil ↗
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StepEmail;
